module.exports = __webpack_public_path__ + "assets/img/2_811_big.f10b50b3.jpg";